import { BaseModal } from '@theme/modal';

export class SiteDrawer extends BaseModal {
  #panel = null;

  connectedCallback() {
    super.connectedCallback();
    this.#panel = this.querySelector('[data-ref="panel"]');
    this.addEventListener('keydown', this.#onKeyDown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.#onKeyDown);
  }

  onOpen() {
    this.triggerElement?.setAttribute('aria-expanded', 'true');
    this.#panel?.focus();
  }

  onClose() {
    this.triggerElement?.setAttribute('aria-expanded', 'false');
  }

  #onKeyDown = (event) => {
    if (event.key !== 'Tab') return;

    const focusableElements = this.#panel?.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusableElements?.length) return;

    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };
}

if (!customElements.get('site-drawer')) {
  customElements.define('site-drawer', SiteDrawer);
}
